import {ConnectedComponent} from '@lib/ConnectedComponent';
import {appSelectors} from '@lib/store/appState';
import {MediaQuery} from '@services/MediaQuery';
import {WindowService} from '@services/WindowService';

export class WindowHeight extends ConnectedComponent {
  private window = WindowService.create();
  private mq = MediaQuery.create();

  constructor() {
    super();
    this.changeOrientation = this.changeOrientation.bind(this);
  }

  didMount() {
    this.resize = this.resize.bind(this);

    if (this.mq.isDesktop()) {
      this.window.onResize.connect(this.resize);
    }

    this.resize();

    this.observe(appSelectors.selectOrientation, this.changeOrientation);
  }

  resize() {
    const height = window.innerHeight;
    this.element && (this.element.style.height = `${height}px`);
  }

  changeOrientation() {
    if (this.mq.isPhone()) {
      this.resize();
    }
  }
}
